import { gql } from 'apollo-angular'

export default gql`
  mutation edit_scanner_by_pk($id: Int!, $_set: scanner_set_input) {
    update_scanner(where: { id: { _eq: $id } }, _set: $_set) {
      affected_rows
      returning {
        id
      }
    }
  }
`
